module.exports = __webpack_public_path__ + "assets/img/Type E (53).97851454.jpg";